import type {
  PagedSalesActions,
  SalesAction,
  SalesActionCompleteRequest,
  SalesActionCreateRequest,
  SalesActionListQuery,
  SalesActionPatchRequest,
  SalesActionProductClonesRequest,
  SalesActionProductClonesResponse,
  SalesActionStatusUpdateRequest,
} from '@shared/types/sales-action';
import { api } from './client';

function buildQueryString(query: SalesActionListQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(key, String(value));
  }
  const qs = params.toString();
  return qs.length === 0 ? '' : `?${qs}`;
}

export async function listSalesActions(
  query: SalesActionListQuery = {},
): Promise<PagedSalesActions> {
  return api.get<PagedSalesActions>(`/api/sales-actions${buildQueryString(query)}`);
}

export async function getSalesAction(id: string): Promise<SalesAction> {
  return api.get<SalesAction>(`/api/sales-actions/${encodeURIComponent(id)}`);
}

export async function createSalesAction(
  body: SalesActionCreateRequest,
): Promise<SalesAction> {
  return api.post<SalesAction>('/api/sales-actions', body);
}

export async function patchSalesAction(
  id: string,
  body: SalesActionPatchRequest,
): Promise<SalesAction> {
  return api.patch<SalesAction>(`/api/sales-actions/${encodeURIComponent(id)}`, body);
}

export async function deleteSalesAction(id: string): Promise<void> {
  return api.delete(`/api/sales-actions/${encodeURIComponent(id)}`);
}

export async function completeSalesAction(
  id: string,
  body: SalesActionCompleteRequest,
): Promise<SalesAction> {
  return api.post<SalesAction>(
    `/api/sales-actions/${encodeURIComponent(id)}/complete`,
    body,
  );
}

export async function updateSalesActionStatus(
  id: string,
  body: SalesActionStatusUpdateRequest,
): Promise<SalesAction> {
  return api.patch<SalesAction>(
    `/api/sales-actions/${encodeURIComponent(id)}/status`,
    body,
  );
}

/**
 * 誤操作救済: 結果 (completed + won/lost) 行を直前の非結果ステータスへ戻す。
 * 戻し先はサーバ側で sales_status_events から推定するため body は空。
 */
export async function restoreSalesActionStatus(id: string): Promise<SalesAction> {
  return api.post<SalesAction>(
    `/api/sales-actions/${encodeURIComponent(id)}/restore-status`,
    {},
  );
}

export async function cloneSalesActionProducts(
  id: string,
  body: SalesActionProductClonesRequest,
): Promise<SalesActionProductClonesResponse> {
  return api.post<SalesActionProductClonesResponse>(
    `/api/sales-actions/${encodeURIComponent(id)}/product-clones`,
    body,
  );
}
